import { ApiBase } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
export class ShomeiApi extends ApiBase {
    loadEntryText() {
        return this.api.get("message/shomei/entry");
    }
    loadEntryRangeText() {
        return this.api.get("message/shomei/entry/range");
    }
    loadEntryCompleteText() {
        return this.api.get("message/shomei/entry/complete");
    }
    loadPrecautionsText() {
        return this.api.get("message/shomei/Precautions");
    }
    loadTuisekiLink() {
        return this.api.get("shomei/tuisekiLink");
    }
    find(shomeiNo) {
        return this.api.get(`shomei/entry/${myPageStore.selectedNyukyokeiyakuNo}/${shomeiNo}`);
    }
    findAll(command) {
        return this.request(command);
    }
    insert(command) {
        return this.request(command);
    }
    loadShosikiSiteiText() {
        return this.api.get("message/shomei/shosikisitei");
    }
}
